import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Trans, useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import "@styles/pages/MemberZone/MemberInquiry/MemberInquiry.scss";
import MemberEnrollmentList from "@pages/MemberZone/MemberInquiry/MemberEnrollmentList";
import MemberWorkshopChangePage from "@pages/MemberZone/MemberInquiry/MemberWorkshopChangePage";

const MemberInquiry = () => {
  const { t, i18n } = useTranslation();

  const currentStep = useSelector((state) => state.formStep.memberInquiry);

  return (
    <Box className="member-inquiry-container">
      <Typography className="title">
        <Trans i18nKey="inquiry:course_inquiry" />
      </Typography>

      {currentStep === 0 && (
        <Typography className="no-data-container">
          <Trans i18nKey="member:no_record" />
        </Typography>
      )}
      {currentStep === 1 && <MemberEnrollmentList />}
      {currentStep === 2 && <MemberWorkshopChangePage />}
    </Box>
  );
};

export default MemberInquiry;
